import Highcharts from 'highcharts'
import Highcharts3d from 'highcharts/highcharts-3d'
import HighchartsMore from 'highcharts/highcharts-more'
import HighchartsVue from 'highcharts-vue'
import borderRadius from 'highcharts-border-radius'

export default {
  install(app) {
    borderRadius(Highcharts)
    // https://www.highcharts.com/docs/getting-started/version-12
    typeof Highcharts3d === 'function' && Highcharts3d(Highcharts)
    typeof HighchartsMore === 'function' && HighchartsMore(Highcharts)

    Highcharts.setOptions({
      credits: {
        enabled: false
      },
      plotOptions: {
        column: {
          borderRadiusTopLeft: 5,
          borderRadiusTopRight: 5,
          borderWidth: 0
        },
        pie: {
          borderWidth: 0
        }
      },
      xAxis: {
        labels: {
          style: {
            color: '#f4f4f4'
          }
        }
      },
      yAxis: {
        labels: {
          style: {
            color: '#f4f4f4'
          }
        }
      },
      legend: {
        itemStyle: {
          // color: '#f4f4f4'
          color: '#369'
        }
      }
    })

    app.use(HighchartsVue)
  }
}
